import { useCallback } from "react";
import { SCROLL_BOTTOM_THRESHOLD } from "../constants";

export function useBottomScroll({
  onReachBottom,
  enabled = true,
  threshold = SCROLL_BOTTOM_THRESHOLD,
}) {
  return useCallback(
    (event) => {
      if (!enabled) return;

      const element = event.currentTarget;
      if (!element) return;

      const reachedBottom =
        element.scrollHeight - element.scrollTop <= element.clientHeight + threshold;

      if (reachedBottom) onReachBottom();
    },
    [enabled, onReachBottom, threshold],
  );
}
